<template>
    <T-dialog v-if="dialog.isShow" @dialogClose="done =>
        { done(), close() }" :dialog="dialog">
        <div slot="content" :class="shit$(`h:450px; bgc:#fff; radius:10px;overflow:hidden;`)">
          <div :class="shit$(`w: 450px;h:100%;float:left;overflow: hidden;line-height:450px;text-align:center;background: #EBEDE8;font-size:0;position: relative;text-align: left;`)">
            <img :class="shit$(`mxw:450px; h:100%;`)" :src="`${env$}static/images/gra-promotion-codetask.jpg`" />
            <h4 :class="shit$(`w:100%;padding:0 40px;font-size:32px;font-weight:normal;position: absolute;left:0;top:48px;color:rgba(255,255,255,0.8);line-height:22px;letter-spacing:0.02em;white-space:nowrap;`)">{{$t("welcome_learn")}}</h4>
            <p :class="shit$(`w:100%;padding:0 40px;font-size:40px;font-weight:bold;position: absolute;left:0;top:80px;color:rgba(255,255,255,0.9);line-height:36px;letter-spacing:0.02em;word-break: break-word;`)">{{$t("program_enlighten_mission")}}</p>
          </div>
          <div :class="shit$(`w:calc(100% - 450px);h:100%;float:left`)">
              <section :class="shit$(`font-w:500; mxw:266px; lh:normal; absolute; top:36px; right:39px;`)">
                <div :class="shit$(`font:24px; letter-s:1.37px; c:#00b5e2; mb:10px;`)">
                    <p>{{$t("unlock_mission_title")}}</p>
                </div>
                <div :class="shit$(`c:#272727; font:18px; letter-s:1.03px; lh:1.5;`)">
                    <p>{{$t("unlock_mission_content")}}</p>
                </div>
            </section>
              <div :class="shit$(`font:16px; font-w:500; letter-s:1.07px; w:190px; absolute; right:77px; bottom:30px;`)">
                <el-button :class="shit$(`p:0px; w:100%; radius:10px; bgc:#00b5e2!; c:#fff!; border:none; hover:opacity:0.6; active:opacity:1;`)">
                    <span @click="unlockFn" :class="shit$(`dis:b; h:45px; lh:45px; font:16px!; font-w:500; letter-s:1.07px; c:#fff;`)">{{$t("unlock_all_mission")}}</span>
                </el-button>
                <span @click="close" :class="shit$(`active:opacity:0.6; dis:b; c:#00b5e2; text-a:c; h:24px; lh:24px; cursor:p; mt:10px;`)">{{$t("try_to_play")}}</span>
            </div> 
          </div>
      </div>
    </T-dialog>
</template>

<script>
import TDialog from "@/code-lab/view/organization/s-dialog.vue";
import {
  store as exchangeStore,
  mutations as exchangeutations
} from "@/code-lab/component/exchange/observable.js";
import { mapState } from "vuex";
export default {
  components: {
    TDialog
  },
  data() {
    return {
      dialog: {
        isShow: false,
        width: "800px",
        closeOnModal: false,
        closeOnEscape: false,
        class: "mission-process-dialog"
      },
      watchs: [
        {
          name: "show",
          cb(show) {
            Object.assign(this.dialog, { isShow: show });
          }
        }
      ]
    };
  },
  methods: {
    close() {
      exchangeutations.mission({ show: false });
    },
    unlockFn() {
      this.$store.commit("SELECTEDMENUERIGHT", "exchange"); 
      this.$router.push({ path: "/exchange" });
      Object.assign(this.dialog, { isShow: false });
    }
  },
  computed: {
    ...mapState(["env$"]),
    show() {
      return exchangeStore.mission.show;
    }
  },
  created() {
    this.watchs = this.watchs.map(({ name, cb }) => {
      return this.$watch(name, cb);
    });
  },
  destroyed() {
    this.close();
    this.watchs.forEach(unWatch => unWatch());
  }
};
</script>

<style lang="scss">
.mission-process-dialog {
  .el-dialog__header {
    padding: 0px !important;
  }
  .el-dialog__body {
    padding: 0px !important;
  }
  .el-dialog {
    border-radius: 10px !important;
    background: transparent !important;
  }
  border-radius: 10px !important;
  background: transparent !important;
}
</style>
